import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Brand, BrandsQueryResponse, DefaultPricing, Pricing} from './_models'
import {Location} from '../../location-management/location-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const BRAND_URL = `${API_URL}/brand`
const GET_BRANDS_URL = `${API_URL}/brand`

const getBrands = (query: string): Promise<BrandsQueryResponse> => {
  return axios
    .get(`${GET_BRANDS_URL}?enabled=true&${query}`)
    .then((d: AxiosResponse<BrandsQueryResponse>) => d.data)
}

const getBrandsArray = (limit = 10, extra = '') : Promise<Array<Brand>> => {
  return axios.get(`${BRAND_URL}?enabled=true&items_per_page=${limit}${extra}`).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}

const getBrandById = (id: ID): Promise<Brand | undefined> => {
  return axios
    .get(`${BRAND_URL}/${id}`)
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const createBrand = (brand: Brand): Promise<Brand | undefined> => {
  return axios
    .post(BRAND_URL, brand)
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const deletePricing = (brand: Brand, pricing: Pricing): Promise<Brand | undefined> => {
  return axios
    .delete(`${BRAND_URL}/pricing/${brand._id}`, {data: pricing})
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const updatePricing = (brand: Brand, pricing: Pricing): Promise<Brand | undefined> => {
  return axios
    .put(`${BRAND_URL}/pricing/${brand._id}`, pricing)
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const updateDefaultPricing = (
  brand: Brand,
  defaultPricing: DefaultPricing
): Promise<Brand | undefined> => {
  return axios
    .put(`${BRAND_URL}/collaborator-payouts/${brand._id}`, defaultPricing)
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const updateBrand = (brand: Brand): Promise<Brand | undefined> => {
  return axios
    .put(`${BRAND_URL}/${brand._id}`, brand)
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const deleteBrand = (brandId: ID): Promise<void> => {
  return axios.delete(`${BRAND_URL}/${brandId}`).then(() => {})
}

const deleteSelectedBrands = (brandIds: Array<ID>): Promise<void> => {
  const requests = brandIds.map((id) => axios.delete(`${BRAND_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getBrands,
  deleteBrand,
  deleteSelectedBrands,
  getBrandById,
  createBrand,
  updateBrand,
  updatePricing,
  deletePricing,
  getBrandsArray,
  updateDefaultPricing,
}
